import React from 'react'
import PropTypes from 'prop-types'

import useStyles from './progress-bar.style'

const ProgressBar = (props) => {
  const classes = useStyles(props)

  return (
    <div className={classes.container}>
      <div className={classes.bar} />
    </div>
  )
}

ProgressBar.defaultProps = {
  progress: 1,
  strokeColor: '#48D6B4'
}

ProgressBar.propTypes = {
  progress: PropTypes.number,
  strokeColor: PropTypes.string
}

export default ProgressBar
